<template>
  <div>
    <div v-if="isLoading" class="loading-overlay">
      <v-progress-circular
        indeterminate
        color="primary"
        size="64"
        class="loading-spinner"
      ></v-progress-circular>
    </div>
    <div class="inner-container">
      <section class="">
        <div class="">
          <div class="d-flex mx-5">
            <b-form-group>
              <b-form-checkbox
                v-model="selectedType"
                :checked="selectedType"
                name="selectedType"
              >
              <div id="input-with-popover">{{ $t('Veuillez effectuer plusieurs travaux') }}</div>
                <b-popover
                  target="input-with-popover"
                  placement="top"
                  triggers="hover focus"
                >
                  {{ $t('Vous pouvez créer un devis pour plusieurs types de travaux') }}
                </b-popover>
              </b-form-checkbox>
            </b-form-group>
          </div>

          <div class="cards-container">
            <v-card
              v-for="(card, index) in cards"
              :key="index"
              class="hover-card"
            >
              <v-checkbox
                v-if="selectedType === true"
                v-model="selectedCards"
                :value="card"
                color="success"
                class="checkbox"
              ></v-checkbox>

              <div
                class="text-center title-color my-3"
                @click="handleCardClick(card)"
              >
                {{ card.title }}
              </div>
            </v-card>
          </div>
          <div class="d-flex justify-content-end mt-4">
            <b-button
              v-if="selectedType === true"
              class="button-pre-style title-color m-3"
              @click="handleCardClick('Type Complexe')"
            >
              {{ $t("CONFIRMER") }}
            </b-button>
          </div>
        </div>
      </section>
    </div>
    <Snackbar ref="snackbar" class="mt-5" />
  </div>
</template>

<script>
import Snackbar from "@/components/ui/errorSnackbar.vue";
import { mapGetters, mapActions } from "vuex";

export default {
  components: {
    Snackbar,
  },
  props: {
    documentType: {
      type: String,
      default: "devis",
    },
    clientId: {
      type: [String, Number],
      default: null,
    },
    dossierId: {
      type: [String, Number],
      default: null,
    },
  },
  data() {
    return {
      isLoading: false,
      selectedType: false,
      selectedCards: [],
      data: {
        brouillon: 1,
        type_devis: "",
        modele_id: "14",
        type: this.documentType,
      },
      cards: [
        { title: "BAR-SE-108", route: "/devis/devisTypesBAR-SE" },
      ],
    };
  },

  computed: {
    ...mapGetters([
      "getTabs",
      "getOnlineUser",
      "getcreationEntreprise",
      "getdevisType",
    ]),
    isSuperAdmin() {
      return this.getOnlineUser.role === "user.super-admin";
    },
    isEntrepriseAdmin() {
      return this.getOnlineUser.role === "user.entreprise-admin";
    },
    isCommercial() {
      return this.getOnlineUser.role === "user.commercial-entreprise";
    },
    isAssistant() {
      return this.getOnlineUser.role === "user.assistant";
    },
  },

  watch: {
    documentType(newVal) {
      this.data.type = newVal;
    },
  },

  methods: {
    ...mapActions([
      "store_devis",
      "updateCreationEntreprise",
      "devisTypeAdd",
      "addGroupe",
    ]),

    async createDevis(typeDevis) {
      try {
        this.isLoading = true;
        if (typeDevis == "Type Complexe" && this.selectedCards.length < 2) {
          this.$refs.snackbar.showSnackbar(
            "Il est nécessaire que vous sélectionniez au moins deux monofiches"
          );
          this.isLoading = false;
          return;
        }
        const payload = {
          ...this.data,
          type_devis: typeDevis,
          entreprise_id: this.getOnlineUser.entreprise.id,
        };
        const clientId = this.clientId || this.$route?.query?.clientId;
        const dossierId = this.dossierId || this.$route?.query?.dossierId;
        if (clientId && dossierId) {
          payload.client_id = parseInt(clientId);
          payload.ocr_dossier_document_id = parseInt(dossierId);
        }
        const response = await this.store_devis(payload);
        if (this.selectedCards.length > 0) {
          const groupes = this.selectedCards.map((card) => ({
            document_id: response.data?.id,
            type_group: card.title,
          }));
          for (const groupe of groupes) {
            await this.addGroupe(groupe);
          }
        } else {
          const groupes = {
            document_id: response.data?.id,
            type_group: typeDevis,
          };
          await this.addGroupe(groupes);
        }

        const devisId = response.data?.id || response.data?.devis?.id;
        this.$router.push(`/devis/update/${devisId}`);
        this.isLoading = false;
      } catch (error) {
        this.isLoading = false;
        throw new Error(error);
      }
    },

    handleTypeChange() {
      this.selectedCards = [];
    },

    handleCardClick(card) {
      this.createDevis(!this.selectedType ? card.title : card);
      this.updateCreationEntreprise(true);
    },
  },
};
</script>

<style lang="scss" scoped>
.loading-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 9999;
}

.loading-spinner {
  z-index: 10000;
}

.button-pre-style {
  background-color: #24316d !important;
  box-shadow: none;
  border-radius: 5px 5px 5px 5px;
  color: white;
}
.checkbox {
  position: absolute;
  top: 10px;
  right: 10px;
  margin: 0;
  transform: scale(1.2);
}

.inner-container {
  cursor: default;
  padding: 0 !important;
  width: 100%;
  margin-top: 50px;
}

.cards-container {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
}

.v-card {
  flex: 1 1 calc(25% - 20px);
  max-width: calc(25% - 20px);
  margin: 10px;
  border-radius: 8px;
  background-color: #24316d;
  font-size: 16px;
  font-weight: 600;
  padding: 20px;
  position: relative;
}

@media only screen and (max-width: 810px) {
  .v-card {
    flex: 1 1 calc(50% - 20px);
    max-width: calc(50% - 20px);
  }
}
@media only screen and (max-width: 620px) {
  .v-card {
    flex: 1 1 calc(100% - 20px);
    max-width: calc(100% - 20px);
  }
}

.hover-card {
  color: white;
  transition: box-shadow 0.3s ease;
}

.hover-card:hover {
  box-shadow: 0px 1px 8px rgba(0, 0, 0, 0.2);
}

.title-color {
  align-items: center;
  color: white;
}
</style>
